import { useState, useEffect } from "react";
// import Link from "next/link";
import { useRouter } from "next/router";
// import styles from "../../styles/Home.module.css";
import Image from "next/image";
import Head from "next/head";
// import CtaButton from "../../components/CtaButton";
import StickyLoginCard from "../../components/StickyLoginCard";
// import BlogPopUpPrimary from "../../components/BlogPopUpPrimary";
// import BlogPopUpSecondary from "../../components/BlogPopUpSecondary";
import useDeviceSize from "../../utils/useDeviceSize";
// import localFont from "@next/font/local";
// import { RiTimerFlashLine } from "react-icons/ri";
const { BLOG_URL, CONTENT_API_KEY } = process.env;
import CtaOne from "@components/CTA/CtaOne";
import { featuredBlogs } from "@constants/blogs";
import FeaturedBlogs from "@components/Blog/FeaturedBlogs";

async function getPost(slug) {
  // console.log("======slug", slug);
  try {
    const res = await fetch(
      `${BLOG_URL}/ghost/api/v3/content/posts/slug/${slug}?key=${CONTENT_API_KEY}&include=tags`,
    ).then((res) => res.json());

    const posts = res.posts;
    // console.log(posts[0].feature_image);
    return posts?.[0] || null;
  } catch (error) {
    console.error("Error fetching post:", slug, error);
    return null;
  }
}

async function getPosts() {
  // curl ""
  const res = await fetch(
    `${BLOG_URL}/ghost/api/v3/content/posts/?key=${CONTENT_API_KEY}&include=tags,authors&filter=primary_tag:clm&fields=title,excerpt,slug,custom_excerpt,feature_image,published_at,reading_time&limit=all`,
  ).then((res) => res.json());

  const posts = res.posts;
  // console.log(posts);

  return posts;
}

// Ghost CMS Request
export const getStaticProps = async ({ params }) => {
  // console.log(params.slug.toString());
  // for pagination
  if (params.slug.toString() === "page") {
    return {
      redirect: {
        destination: "/blog/page/1",
        permanent: false,
      },
    };
  }
  const post = await getPost(params.slug.toString());

  // Return 404 if post not found
  if (!post) {
    return {
      notFound: true,
    };
  }

  // console.log("-----", post?.feature_image);
  // console.log("----",post?.feature_image_alt)
  // console.log("----",post?.feature_image_caption)
  return {
    props: { post },
    revalidate: 24 * 60 * 60,
  };
};

// const biotif1 = localFont({
//   src: [
//     {
//       path: "../../assets/fonts/biotif-regular.ttf",
//       weight: "400",
//       style: "normal",
//     },
//     {
//       path: "../../assets/fonts/biotif-bold.ttf",
//       weight: "700",
//       style: "bold",
//     },
//     {
//       path: "../../assets/fonts/biotif-black.ttf",
//       weight: "900",
//       style: "black",
//     },
//     {
//       path: "../../assets/fonts/biotif-light.ttf",
//       weight: "300",
//       style: "light",
//     },
//   ],
// });

// hello-world - on first request = Ghost CMS call is made (1)
// hello-world - on other requests ... = filesystem is called (1M)

export const getStaticPaths = async () => {
  const posts = await getPosts();
  // console.log(posts);
  // generate the paths
  let paths = [];
  posts.forEach((post) => {
    // console.log(post.slug);
    paths.push({ params: { slug: post.slug.toString() } });
  });
  // console.log("=====================================");
  // console.log(paths);
  // console.log("=====================================");

  // paths -> slugs which are allowed
  // fallback ->
  return {
    paths: paths,
    fallback: true,
  };
};

const Post = (props) => {
  // console.log(props);

  const { post } = props;
  // console.log(post.html);
  const [width, height] = useDeviceSize();
  const router = useRouter();

  const [displayPopUpPrimary, setPopUpPrimary] = useState(true);
  const [displayPopUpSecondary, setPopUpSecondary] = useState(false);

  useEffect(() => {
    (() => {
      // Check if the user has already subscribed the primary pop up
      if (localStorage.getItem("blogPopUpPrimary") === "true") {
        setPopUpPrimary(false);

        // Check if the user has already subscribed the secondary pop up
        if (localStorage.getItem("blogPopUpSecondary") !== "true")
          setPopUpSecondary(true);
      }
    })();
  }, []);

  if (router.isFallback) {
    return <h4>Loading...</h4>;
  }

  const pageProduct = post?.primary_tag?.slug || "";

  const closePrimaryPopUp = () => {
    setPopUpPrimary(false);

    // Show secondary pop up only if the user has not subscribed to it
    if (localStorage.getItem("blogPopUpSecondary") !== "true")
      setTimeout(() => setPopUpSecondary(true), 5000);
  };

  const closeSecondaryPopUp = () => {
    setPopUpSecondary(false);
  };
  // console.log(post);
  return (
    <div className="w-full md:mt-20 mt-8">
      <Head>
        <meta charSet="utf-8" />
        <title>{post?.title}</title>
        <meta
          name="description"
          content={post.meta_description ?? post.excerpt}
        />
        <meta name="twitter:title" content={post.meta_title ?? post.excerpt} />
        <meta
          name="twitter:description"
          content={post.meta_description ?? post.excerpt}
        />
        <link
          rel="canonical"
          href={`https://www.bolosign.com/blog/${post.slug}/`}
        />
        <meta
          property="og:url"
          content={`https://www.bolosign.com/blog/${post.slug}/`}
        />
        <meta
          property="twitter:url"
          content={`https://www.bolosign.com/blog/${post.slug}/`}
        />
      </Head>
      {/* <div className={`w-full block ${styles.blogTop} sm:pt-16 sm:pb-10 px-4 md:px-8 xxl:px-0`}>
        <div className="max-w-screen-mxl w-full mx-auto flex relative z-10 flex-col translate-y-16 sm:translate-y-0">
          <div className="flex flex-col w-full bg-gray-200 px-[10px] py-[10px] md:px-[48px] lg:px-[48px] md:pt-[48px] md:pb-[16px] lg:pb-[16px]">
            <h1
              className={`${biotif1.className} text-[24px] md:text-[32px] lg:text-[32px] leading-[1] font-black`}
            >
              {post.title}
            </h1>
            <div className="mt-[8px] w-full text-[12px] leading-[16px] py-[1px]">
              {new Date(post.published_at).toShortFormat()}
            </div>
            <div className="flex flex-row mt-[8px]">
              <Image
                className="w-[32px] rounded-[16px]"
                loading="lazy"
                src="https://i.imgur.com/CbNehZg.png"
                width={100}
                height={100}
                alt="paresh"
              />
              <div
                className={`${biotif1.className} flex justify-center items-center text-[12px] leading-[16px] ml-[16px]`}
              >
                Paresh @Boloforms
              </div>
              <div className="flex grow" />
              <div
                className={`${biotif1.className} flex text-[12px] leading[1.5] items-center justify-center`}
              >
                <RiTimerFlashLine size="18px" className="mr-[4px]" />
                {post.reading_time} min read
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div style={{background: 'rgba(233, 216, 253)'}} className="relative z-10 flex flex-col md:flex-row lg:flex-row w-full py-[5px] px-[10px] md:px-[80px] lg:px-[80px] md:py-[15px] lg:py-[15px]">
          <div className={`${biotif1.className} text-[14px] leading-[18px] font-semibold py-[4px] md:py-[18px] lg:py-[18px]`} >Use AI to answer all your Excel & Google Sheets related queries. Try SheetGod for free now.</div>
          <div className="flex grow" />
          <a href='https://sheetgod.boloforms.com' target='_blank'  rel="noreferrer" 
          className={`${biotif1.className} text-center  md:h-[44px] lg:h-[44px] md:w-[150px] lg:w-[150px] border-[2px] border-[#44337A] animate-blinkBorder text-[14px] leading-[18px] font-semibold my-[5px] py-[13px] px-[40px] bg-white rounded-[8px]`}>
            Try now!
          </a>
      </div> */}
      <div className="max-w-screen-xl mx-auto px-4 md:px-8 txl:px-0">
        {/* heading  */}
        <div className="text-center max-w-screen-lg mx-auto">
          <CtaOne
            heading2={post?.title}
            paragraph={post?.meta_description}
            paragraphStyling={`max-w-screen-md mx-auto`}
          />
        </div>
        {/* image  */}
        <div className="w-full mx-auto mt-8 mb-10 sm:mb-16 border border-black rounded-xl p-4 md:p-8">
          <Image
            src={post?.feature_image}
            width="10"
            height="10"
            className="w-full h-auto rounded-xl"
            alt={post?.feature_image_alt}
          />
        </div>
        <div
          className={
            "flex flex-col gap-y-10 sm:gap-y-16 z-10 relative md:mt-[20px] lg:flex-row-reverse justify-between lg:gap-12 xxl:gap-20 mx-auto"
          }
        >
          <div className="self-center lg:self-start lg:sticky lg:top-[140px] flex justify-center">
            <StickyLoginCard pageProduct={pageProduct} />
          </div>
          <div className="website-blogs flex-1 break-words tracking-wide">
            <div
              dangerouslySetInnerHTML={{
                __html: post?.html
                  ?.replaceAll("<p", "<p class='my-4' ")
                  ?.replaceAll("<h2", "<h2 class='my-4' "),
              }}
            ></div>
          </div>
        </div>
        {/* author  */}
        <div className="flex justify-between items-center flex-row gap-4 flex-wrap mt-10 py-4 border-y border-gray-300">
          <div className="flex items-center gap-3">
            <div className="w-[55px] h-[55px]">
              <Image
                className="w-full rounded-full object-cover"
                loading="lazy"
                src="https://i.imgur.com/CbNehZg.png"
                width={100}
                height={100}
                alt="paresh"
              />
            </div>
            <div className="">
              <h3 className="">Paresh Deshmukh</h3>
              <p className="">Co-Founder, BoloForms</p>
            </div>
          </div>
          <div className="">
            <p className="text-lg">
              {new Date(post.published_at).toShortFormat()}
            </p>
          </div>
        </div>
      </div>
      {/* articles */}
      <div className="max-w-screen-mxl mx-auto px-4 md:px-8 txl:px-0 my-20 md:mt-32">
        <FeaturedBlogs blogCards={featuredBlogs} />
      </div>
    </div>
  );
};

export default Post;

{
  /* {displayPopUpPrimary && (
        <BlogPopUpPrimary
          closePopUp={closePrimaryPopUp}
          product={pageProduct}
        />
      )}
      {displayPopUpSecondary && (
        <BlogPopUpSecondary
          closePopUp={closeSecondaryPopUp}
          product={pageProduct}
        />
      )} */
}
{
  /*<h4 className="pt-5 pb-8 text-2xl font-semibold">{post.title}</h4>*/
}
{
  /*<div className="flex my-2">*/
}
{
  /*  <Image*/
}
{
  /*    className="w-8 h-8 rounded-full"*/
}
{
  /*    src="https://blog.boloforms.com/content/images/size/w100/2022/07/paresh-website-photo.jpeg"*/
}
{
  /*    alt="Paresh from BoloForms"*/
}
{
  /*    width={50}*/
}
{
  /*    height={50}*/
}
{
  /*  />*/
}
{
  /*  <div className="ml-2">*/
}
{
  /*    <div className="font-medium text-sm">Paresh from BoloForms</div>*/
}
{
  /*    <div className="text-xs text-slate-400">*/
}
{
  /*      {new Date(post.published_at).toDateString()} - {post.reading_time}{" "}*/
}
{
  /*      min*/
}
{
  /*    </div>*/
}
{
  /*  </div>*/
}
{
  /*</div>*/
}
{
  /*<br />*/
}
{
  /*{post.feature_image && (*/
}
{
  /*  <Image*/
}
{
  /*    src={post.feature_image}*/
}
{
  /*    alt={post.title}*/
}
{
  /*    className="mr-6 max-w-[120px] sm:max-w-[300px] md:max-w-[400px] text-xs h-full object-cover rounded-l-xl"*/
}
{
  /*    // blurDataURL="data:..." automatically provided*/
}
{
  /*    // placeholder="blur" // Optional blur-up while loading*/
}
{
  /*    width={width < 620 ? 120 : 300}*/
}
{
  /*    height="100"*/
}
{
  /*    // blurDataURL="data:..." automatically provided*/
}
{
  /*    // placeholder="blur" // Optional blur-up while loading*/
}
{
  /*  />*/
}
{
  /*)}*/
}

{
  /*<div className="mt-20  flex flex-col items-center">*/
}
{
  /*  <h4 className="text-xl font-semibold capitalize">*/
}
{
  /*    Try BoloForms for Free*/
}
{
  /*  </h4>*/
}
{
  /*  <div className="-mt-12">*/
}
{
  /*    <CtaButton productName={"Approvals"} />*/
}
{
  /*  </div>*/
}
{
  /*</div>*/
}
